export default "__VITE_ASSET__DvIHw7yj__"